import { lazy } from 'react';
const TrialBalance = lazy(() => import('./TrialBalance'));

const TrialBalanceRoutes = [
  {
    path: '/trialbalance',
    component: TrialBalance
  }
];

export default TrialBalanceRoutes;
